import React from 'react';
import ReactGA from "react-ga4"

const UserContext = React.createContext();
const initialState = {
  profile: {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    name: "",
    business: ""
  },
  affiliateLink: null,
  showProfile: false,
  settingsForm: {
    name: { id: 'name', label: 'Name', value: '', modified: false },
    firstName: { id: 'firstname', label: 'First Name', value: '', modified: false },
    lastName: { id: 'lastname', label: 'Last Name', value: '', modified: false },
    email: { id: 'email', label: 'Email', value: '', modified: false },
    business: { id: 'business', label: 'Business Name', value: '', modified: false },
    password: { id: 'password', label: 'Password', value: '', modified: false },
  },
  token: '',
  loggedIn: false,
  productRequestProduct: null,
  productRequestLink: null,
  productRequestDetails: null,
  productRequestUrgency: null,
  productRequestLoggedIn: false,
  productRequestShowModal: false,
}

function userReducer(state, action)
{
  switch(action.type) {
    case 'user/sync':
    case 'sync':
      return {  
        ...state,
        profile: action.payload.user,
        token: action.payload.token,
        loggedIn: true,
      }

    case 'user/me':
    case 'me':
      return {
        ...state,
        profile: action.payload.me,
        loggedIn: true
      }

    case 'user/logout':
    case 'logout':
      return {
        ...state,
        profile: null,
        token: null,
        loggedIn: false,
      }

    case 'user/update':
      return {
        ...state,
        profile: action.payload.user
      }

    case 'user/login':
      return {
        ...state,
        loggedIn: true
      }

    case 'affiliate/set':
      return {
        ...state,
        affiliateLink: action.payload.affiliateLink
      }

    case 'profile/open':
      return {
        ...state,
        showProfile: true
      }

    case 'profile/close':
      return {
        ...state,
        showProfile: false
      }
    case 'profile/modify':
      return {
        ...state,
        settingsForm: action.payload
      }
    case 'productRequest/product':
      return {
        ...state,
        productRequestProduct: action.payload.product,
        productRequestLink: action.payload.link,
      }
    case 'productRequest/details':
      return {
        ...state,
        productRequestDetails: action.payload.details,
        productRequestUrgency: action.payload.urgency,
      }
    case 'productRequest/loggedIn':
      return {
        ...state,
        productRequestLoggedIn: action.payload,
      }
    case 'productRequest/showModal':
      return {
        ...state,
        productRequestShowModal: action.payload,
      }
    default:
      return state;
  }
}

function UserProvider({children})
{
  const [state, dispatch] = React.useReducer(userReducer, initialState);
  const value = [state, dispatch];

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

function useUser() {
  const context = React.useContext(UserContext)
  if (context === undefined) {
    throw new Error("useUser must be invoked within a UserProvider")
  }

  return context;
}

export {UserProvider, useUser}
